<script>
import { reactive, toRefs, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
// import { Modal } from 'ant-design-vue'
export default {
  setup() {
    const route = useRoute()
    const store = useStore()
    const state = reactive({
      windowPath: ''
    })
    const formatPath = val => {
      const queryParams = route.query
      const userInfo = store.state.user.userInfo
      const env = process.env.VUE_APP_MODE
      const systemId = store.state.app.otherSystemId
      const systemName = store.state.app.otherSystemName
      const menuName = store.state.app.otherMenuName
      let paramsStr = ''

      Object.keys(queryParams).forEach(key => {
        if (key !== 'target') {
          paramsStr += `&${key}=${queryParams[key]}`
        }
      })
      let windowPath =
        val +
        (val && val.indexOf('?') > -1 ? '&' : '?') +
        `token=${userInfo.token}&email=${userInfo.email}&userId=${
          userInfo.userId
        }&userName=${userInfo.userName}&jobNumber=${
          userInfo.jobNumber
        }&lang=${localStorage.getItem(
          'lang'
        )}&env=${env}&_t=${new Date().getTime()}&systemId=${systemId}${paramsStr}&systemName=${systemName}&menuName=${menuName}`
      return windowPath
    }
    /**
     * iframe窗口加载完成后
     */
    const onLoad = () => {
      const btnRoot = sessionStorage.getItem('permission_button')
      window.currentIframe?.contentWindow?.postMessage(
        {
          type: 'global',
          value: {
            btnCode: btnRoot && JSON.parse(btnRoot)
          }
        },
        '*'
      )
    }
    const renderIframe = target => {
      let isExit = false
      const nodeList = document.querySelectorAll('iframe')
      window.currentIframe = null
      Array.prototype.forEach.call(nodeList, item => {
        if (item.id === target) {
          item.style.display = 'block'
          window.currentIframe = item
          isExit = true
        } else {
          item.style.display = 'none'
        }
      })
      if (!isExit && target) {
        const iframe = document.createElement('iframe')
        iframe.src = formatPath(target)
        iframe.width = '100%'
        iframe.className = 'windowIframe'
        iframe.id = target
        iframe.allow = 'clipboard-read; clipboard-write'
        document
          .querySelector('.portal-ant-layout-content')
          ?.appendChild(iframe)
        window.currentIframe = iframe
      }
      if (window.currentIframe) {
        window.currentIframe.onload = () => {
          onLoad()
        }
      }
    }
    watch(
      () => route.query.target,
      val => {
        renderIframe(val)
      },
      {
        immediate: true
      }
    )
    return {
      formatPath,
      route,
      store,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="scss">
.windowIframe {
  /* height: 100%; */
  height: calc(100%);
}
</style>
